<template>
  <div v-if="Seleccionado">
    <Cartilla :id_plan="Seleccionado.id_plan"></Cartilla>
  </div>
  
</template>

<script>
import { mapActions, mapState } from "vuex";
import Cartilla from "@/components/Efectores/Cartilla";
import API from "../lib/API";
import LUM from "../lib/LUM";
export default {
  data() {
    return {
      valida: true,
    };
  },
  components: {
    Cartilla,
  },
  computed: {
    ...mapState("beneficiarios", ["Titular", "GrupoFamiliar", "Seleccionado"]),
    ...mapState("autogestion", ["Usuario"]),
    logueado() {
      return this.Seleccionado !== undefined && this.Seleccionado !== null;
    },
  },
  methods: {
    ...mapActions("autogestion", ["inicializar"]),
    ...mapActions("beneficiarios", ["select"]),
  },
  async mounted() {
    if (!this.Usuario) {
      await this.inicializar();
      if (!this.Usuario) {
        this.$router.push({ name: "Autogestion" });
      }
    }
    if (this.Usuario && this.Seleccionado == undefined) {
      let ben = await API.Beneficiarios.traerUno(this.Usuario.UserId);
      this.select(ben);
    }
  },
};
</script>

<style></style>
